import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { SuccessComponent } from 'src/app/shared/modals/success/success.component';
import { TabsService } from '../../tabs.service';
import { EditGroupComponent } from './edit-group/edit-group.component';
import { EditRoleComponent } from './edit-role/edit-role.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UsersService } from './users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateOrganisationHierarchyService } from '../create-organisation-hierarchy/create-organisation-hierarchy.service';
import { MatSort } from '@angular/material/sort';
import { AlertComponent } from 'src/app/shared/modals/alert/alert.component';
import { SettingsService } from '../settings/settings.service';
import { Subscription, first } from 'rxjs';
import { GeneralModalComponent } from 'src/app/shared/modals/general-modal/general-modal.component';
import { SharedService } from 'src/app/shared/shared.service';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import { ImpersonationService } from 'src/app/shared/services/impersonation.service';
import { AdminChangePasswordDialogComponent } from './admin-change-password-dialog/admin-change-password-dialog.component';
import * as XLSX from 'xlsx';


@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
	@ViewChild(MatPaginator)
	paginator!: MatPaginator;
	private readonly baseDisplayedColumns: string[] = ['status', 'name', 'role', 'email', 'location', 'actions'];
	displayedColumns: string[] = [...this.baseDisplayedColumns];
	displayedRoleColumns: string[] = ['name', 'access', 'edit', 'delete'];
	displayedGroupColumns: string[] = ['name', 'active', 'edit', 'delete'];
	displayedColumnsManagers: string[] = ['location', 'manager'];
	dataSource: MatTableDataSource<any>;
	@ViewChild('paginatorUsers')
	paginatorUsers!: MatPaginator;
	@ViewChild('paginatorGroups')
	paginatorGroups!: MatPaginator;
	@ViewChild('paginatorRoles')
	paginatorRoles!: MatPaginator;
	@ViewChild('paginatorManagers')
	paginatorManagers!: MatPaginator;
	isLoading = true;
	dataRoleSource = new MatTableDataSource<any>([]);
	groupDataSource = new MatTableDataSource<any>([]);
	blockLoader: string = 'blockLoader';
	@Input() organisationId: string = '';
	xlsxFileName: string = '';
	xlsxFile: any;
	organisationHierarchy: any = [];
	hierarchies: any = [];
	organizationHierarchySub;
	@ViewChild(MatSort) sort: any;
	orgCode: any;
	users: any = [];
	dataSourceManagers: MatTableDataSource<any>;
	orgRoles: any = [];
	managers: any = [];
	hierarchy: any;
	managerRoleFilterValue = "all";
	bulkUploadDetails: string = "";
	bulkUploadSub: Subscription;
	orgDetailsSub: any;
	lastUserDoc: any;
	hasPreviousUsers: boolean = false;
	hasMoreUsers: boolean = true;
	hasMoreFromServer: boolean = false;
	usersPageSize: number = 100;
	currentIndex = [0, 0];
	rolesData: any = {};
	searchUser = '';
	searchDebounceTimer: any = null;
	searchRequestCounter = 0;
	activeSearchRequestId = 0;
	isSearchMode = false;
	searchedUsers: any[] = [];
	allUsersForSearch: any[] = [];
	hasLoadedAllUsersForSearch = false;
	managerDetails: any = [];
	areManagersLoading = true;
	isSearchingUser = false;
	numUsers: number = 0;
	canImpersonate: boolean = false;
	currentUserId: string = '';
	isImpersonatingLoadingByUserId: { [key: string]: boolean } = {};
	isChangingPasswordByUserId: { [key: string]: boolean } = {};

	constructor(
		public dialog: MatDialog,
		private usersService: UsersService,
		private spinner: NgxSpinnerService,
		private tabsService: TabsService,
		private snackbar: MatSnackBar,
		private createOrganisationService: CreateOrganisationHierarchyService,
		private settingsService: SettingsService,
		private sharedService: SharedService,
		private postHogService: PostHogService,
		private impersonationService: ImpersonationService
	) {
		this.currentUserId = localStorage.getItem('userId') ?? "";

		this.organizationHierarchySub = this.tabsService.organisationId$.subscribe(async organisationId => {
			this.organisationId = organisationId;
			// console.log(this.organisationId);

			if (this.organisationId) {
				this.hasLoadedAllUsersForSearch = false;
				this.allUsersForSearch = [];
				this.organisationHierarchy = await this.createOrganisationService.getOrganisationHierarchy(this.organisationId);
				await this.getRoles();
				await this.getUsers();
				this.getOrganizationDetails();
			}
		});

		this.bulkUploadSub = this.usersService.bulkUploadDetails$.subscribe(details => {
			this.bulkUploadDetails = details;
		});

		this.dataSource = new MatTableDataSource();
		this.dataSourceManagers = new MatTableDataSource();
	}

	setDataSourceAttributes() {
		this.dataSource.sort = this.sort;
	}

	async ngOnInit() {
		this.getGroups();
		// setTimeout(() => {
		// 	this.setupExcelFileListener();
		// }, 0)
		// console.log('this.dataSource', this.dataSource)
	}

	setupExcelFileListener() {
		const xlsxFileInput = document.getElementById('xlsx-file-input');
		// console.log(xlsxFileInput);
		if (xlsxFileInput) {
			xlsxFileInput.onchange = (event) => {
				this.xlsxFileChange(event);
			};
		} else {
			setTimeout(() => {
				this.setupExcelFileListener();
			}, 1000);
		}
	}

	ngAfterViewInit() {
		this.dataSource.paginator = this.paginatorUsers;
		this.groupDataSource.paginator = this.paginatorGroups;
		this.dataRoleSource.paginator = this.paginatorRoles;
	}

	ngOnDestroy() {
		this.organizationHierarchySub.unsubscribe();
		if (this.orgDetailsSub) {
			this.orgDetailsSub.unsubscribe();
		}
		if (this.searchDebounceTimer) {
			clearTimeout(this.searchDebounceTimer);
		}
	}

	editUser(userData?: string) {
		// console.log(userData);
		if (!this.organisationHierarchy?.length) {
			this.snackbar.open('This organisation does not have hierarchy levels.', 'ok', {
				duration: 3000
			});
			return;
		}

		const dialogRef = this.dialog.open(UserEditComponent, {
			maxWidth: '80%',
			minWidth: '80%',
			data: {
				userData,
				organisationId: this.organisationId,
				orgCode: this.orgCode
			}
		});

		dialogRef.afterClosed().subscribe(async result => {
			if (result?.status === 'success') {
				let msg = '';
				if (userData) {
					msg = 'User edited successfully!';
					await this.refreshUsers('edit');
				} else {
					msg = 'User added successfully!';
					setTimeout(async () => {
						await this.refreshUsers('add');
					}, 500);
				}
				this.snackbar.open(msg, "OK", {
					duration: 1000
				});
			}
		});
	}

	async getUsers() {
		const result = await this.usersService.getInitialUsers(this.organisationId);

		if (result.lastUserDoc) {
			let users: any = result.users;
			this.users = [];

			if (users && users.length >= 1) {
				const unformattedUsers = users;

				for (let user of unformattedUsers) {
					let userObj: any = {
						id: user.id
					};

					for (let key of Object.keys(user)) {
						userObj[key] = user[key];
					}

					this.users.push(userObj);
				}

				for (let u of this.users) {
					const roleId = String(u.roleId);
					u.role = this.rolesData[roleId];
				}

				this.lastUserDoc = result.lastUserDoc;
				this.currentIndex = [0, users.length];
				this.hasMoreFromServer = users.length >= this.usersPageSize;
				this.syncUsersCountFromLoaded();
				this.updatePaginationState();

				this.dataSource = new MatTableDataSource<any>(this.users);
				this.dataSource.sort = this.sort;
				this.dataSource.paginator = this.paginatorUsers;
			}
		} else {
			this.users = [];
			this.currentIndex = [0, 0];
			this.hasMoreFromServer = false;
			this.syncUsersCountFromLoaded();
			this.updatePaginationState();
			this.setUsersDataSource([]);
		}
	}

	getDisplayValue(value: string, k: number) {
		let currValues = this.hierarchy[k].values;

		for (let i = 0; i < currValues.length; i += 1) {
			let lvl = currValues[i];
			if (lvl.value === value) {
				return lvl.displayValue;
			}
		}

		return "";
	}

	async nextUsers() {
		if (this.currentIndex[1] < this.users.length) {
			const newBeginningIndex = Number(this.currentIndex[0]) + this.usersPageSize;
			const newEndingIndex = Number(this.currentIndex[1]) + this.usersPageSize;
			this.currentIndex = [newBeginningIndex, newEndingIndex];

			const users = this.users.slice(this.currentIndex[0], this.currentIndex[1]);
			this.dataSource = new MatTableDataSource<any>(users);
			this.dataSource.sort = this.sort;
			this.dataSource.paginator = this.paginatorUsers;
			this.updatePaginationState();
		} else {
			await this.spinner.show("blockLoader");
			const allUsers: any = await this.usersService.getMoreUsers(this.organisationId, this.lastUserDoc);
			await this.spinner.hide("blockLoader");

			if (allUsers.status === "no_more_leads") {
				this.hasMoreFromServer = false;
				this.syncUsersCountFromLoaded();
				this.updatePaginationState();
				return;
			} else if (allUsers.status === "available") {
				this.lastUserDoc = allUsers.lastUserDoc;

				const users: any = allUsers.users;
				this.hasMoreFromServer = users.length >= this.usersPageSize;
				const newBeginningIndex = Number(this.currentIndex[0]) + this.usersPageSize;
				const newEndingIndex = Number(this.currentIndex[1]) + users.length;
				this.currentIndex = [newBeginningIndex, newEndingIndex];

				if (users && users.length >= 1) {
					const unformattedUsers = users;

					for (let user of unformattedUsers) {
						let userObj: any = {
							id: user.id,
						};

						for (let key of Object.keys(user)) {
							userObj[key] = user[key];
						}

						this.users.push(userObj);
					}

					for (let u of this.users) {
						const roleId = String(u.roleId);
						u.role = this.rolesData[roleId];
					}
					this.syncUsersCountFromLoaded();
					this.updatePaginationState();

					this.dataSource = new MatTableDataSource<any>(users);
					this.dataSource.sort = this.sort;
					this.dataSource.paginator = this.paginatorUsers;
				}
			}
		}
	}

	async previousUsers() {
		if (this.currentIndex[0] === 0) {
			this.updatePaginationState();
			return;
		}

		const newBeginningIndex = Number(this.currentIndex[0]) - this.usersPageSize;
		let newEndingIndex = Number(this.currentIndex[1]) - this.usersPageSize;
		if (newEndingIndex % this.usersPageSize !== 0) {
			newEndingIndex = Math.ceil(newEndingIndex / this.usersPageSize) * this.usersPageSize;
		}
		this.currentIndex = [newBeginningIndex, newEndingIndex];
		const users = this.users.slice(this.currentIndex[0], this.currentIndex[1]);
		this.dataSource = new MatTableDataSource<any>(users);
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginatorUsers;
		this.updatePaginationState();
	}

	async refreshUsers(type: string) {
		if (type === 'latest' || type === 'add') {
			// Capture PostHog event when user clicks Refresh Users button
			if (type === 'latest') {
				const userEmail = localStorage.getItem('username');
				const role = localStorage.getItem('roleId');

				this.postHogService.capture('Refresh User', {
					'User email': userEmail,
					'device_type': 'Web',
					'role': role
				});
			}

			await this.spinner.show("blockLoader");
			const result = await this.usersService.getInitialUsers(this.organisationId);
			await this.spinner.hide("blockLoader");

			if (result.lastUserDoc) {
				const users = result.users;

				for (let user of users) {
					const userSearch = this.users.findIndex((searchUser: any) => searchUser.id === user.id);
					if (userSearch === -1) {
						this.users.unshift(user);
					}
				}

				for (let u of this.users) {
					const roleId = String(u.roleId);
					u.role = this.rolesData[roleId];
				}
				this.syncUsersCountFromLoaded();

				this.currentIndex = [0, users.length];
				this.hasMoreFromServer = users.length >= this.usersPageSize;
				let usersToShow = this.users.slice(0, users.length);
				this.dataSource = new MatTableDataSource<any>(usersToShow);
				this.dataSource.sort = this.sort;
				this.dataSource.paginator = this.paginatorUsers;
				this.updatePaginationState();
			}
		} else if (type === 'delete' || type === 'edit') {
			let slicedUsers = this.users.slice(this.currentIndex[0], this.currentIndex[1]);
			this.dataSource = new MatTableDataSource<any>(slicedUsers);
			this.dataSource.sort = this.sort;
			this.dataSource.paginator = this.paginatorUsers;
			this.updatePaginationState();
		}
	}

	getGroups() {
		this.usersService.getGroups(this.organisationId).subscribe((group) => {
			if (group.length > 0) {
				this.groupDataSource = new MatTableDataSource<any>(group);
				this.groupDataSource.paginator = this.paginatorGroups;
			}
		});
	}

	async getRoles() {
		const rolesDataObs = this.usersService.getRoles(this.organisationId);
		const roles: any = await this.sharedService.getObservableRes(rolesDataObs);

		if (roles.length > 0) {
			this.orgRoles = roles;

			for (let role of roles) {
				this.rolesData[role.id] = role.name;
			}

			this.dataRoleSource = new MatTableDataSource<any>(roles);
			this.dataRoleSource.paginator = this.paginatorRoles;
		}

		this.updateCanImpersonate();
	}

	async updateCanImpersonate() {
		const currentRoleId = localStorage.getItem('roleId') ?? "";
		let currentRoleName = String(this.rolesData[currentRoleId] ?? "").toLowerCase();

		// Fallback: current admin role may not be part of the selected org role list.
		// In that case, resolve role directly from roles collection.
		if (!currentRoleName && currentRoleId) {
			const roleData: any = await this.sharedService.getRoleData(currentRoleId);
			currentRoleName = String(roleData?.name ?? "").toLowerCase();
		}

		this.canImpersonate = currentRoleName === 'admin';
		this.displayedColumns = [...this.baseDisplayedColumns];
	}

	isImpersonateDisabled(user: any) {
		if (!this.canImpersonate) {
			return true;
		}

		if (!user || !user.id) {
			return true;
		}

		if (user.id === this.currentUserId) {
			return true;
		}

		if (!user.status) {
			return true;
		}

		return Boolean(this.isImpersonatingLoadingByUserId[user.id]);
	}

	async impersonateUser(targetUser: any) {
		if (!targetUser || !targetUser.id || this.isImpersonateDisabled(targetUser)) {
			return;
		}

		const dialogRef = this.dialog.open(AlertComponent, {
			data: {
				title: "Are you sure?",
				subTitle: `Do you want to impersonate user: ${targetUser.name || targetUser.email}?`,
				rightBtnText: "Impersonate"
			}
		});

		dialogRef.afterClosed().subscribe(async result => {
			if (!result) {
				return;
			}

			const targetUserId = targetUser.id;
			try {
				this.isImpersonatingLoadingByUserId[targetUserId] = true;
				await this.spinner.show("blockLoader");
				await this.impersonationService.startImpersonation(targetUserId);
				await this.spinner.hide("blockLoader");
				window.location.href = '/';
			} catch (err: any) {
				await this.spinner.hide("blockLoader");
				this.isImpersonatingLoadingByUserId[targetUserId] = false;

				const errMsg = err?.error?.message || err?.message || 'Unable to impersonate this user.';
				this.snackbar.open(errMsg, "OK", {
					duration: 3500
				});
			}
		});
	}

	isChangePasswordDisabled(user: any): boolean {
		if (!this.canImpersonate || !user?.id) {
			return true;
		}

		if (user.id === this.currentUserId || !user.status) {
			return true;
		}

		return Boolean(this.isChangingPasswordByUserId[user.id]);
	}

	changeUserPassword(targetUser: any): void {
		if (!targetUser?.id || this.isChangePasswordDisabled(targetUser)) {
			return;
		}

		const targetUserId = targetUser.id;
		this.isChangingPasswordByUserId[targetUserId] = true;

		const dialogRef = this.dialog.open(AdminChangePasswordDialogComponent, {
			width: '560px',
			maxWidth: 'calc(100vw - 32px)',
			maxHeight: 'calc(100vh - 32px)',
			disableClose: true,
			autoFocus: false,
			restoreFocus: true,
			panelClass: 'admin-password-dialog-panel',
			data: {
				id: targetUserId,
				name: targetUser.name || '',
				email: targetUser.email || ''
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.isChangingPasswordByUserId[targetUserId] = false;

			if (result?.success) {
				const message = result.mustChangePassword
					? `Password changed for ${targetUser.name || targetUser.email}. The user must replace it after login.`
					: `Password changed successfully for ${targetUser.name || targetUser.email}.`;
				this.snackbar.open(
					message,
					'OK',
					{ duration: 4500 }
				);
			}
		});
	}

	editRole(roleData?: string) {
		const dialogRef = this.dialog.open(EditRoleComponent, {
			maxWidth: '80%',
			minWidth: 'fit-content',
			data: {
				roleData,
				organisationId: this.organisationId,
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log(`Dialog result: ${result}`);
		});
	}

	editGroup(data?: string) {
		// console.log('createLevelBrands')
		const dialogRef = this.dialog.open(EditGroupComponent, {
			maxWidth: '80%',
			minWidth: 'fit-content',
			data: {
				data,
				organisationId: this.organisationId,
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			console.log(`Dialog result: ${result}`);
		});
	}

	// async deleteUser(element: any, index: number) {
	// 	console.log("deleteSubject", element.id);
	// 	await this.spinner.show("blockLoader");
	// 	await this.usersService.deleteUser(element.id);
	// 	await this.spinner.hide("blockLoader");
	// 	this.dialog.open(SuccessComponent, { data: { title: "Deleted!", subTitle: "User deleted successfully." } });
	// }

	async deleteUser(element: any, data: any = null) {
		// console.log('element',element)
		const dialogRef = this.dialog.open(AlertComponent, {
			data: {
				title: "Are you sure?",
				subTitle: `Are you sure you want to delete user: ${element.name}?`
			},
		});
		dialogRef.afterClosed().subscribe(async result => {
			console.log(`Dialog result: ${result}`);
			if (result) {
				await this.spinner.show("blockLoader");
				const res: any = await this.usersService.deleteUser(element.id);
				await this.spinner.hide("blockLoader");

				if (!res || res.status !== 'success') {
					this.dialog.open(SuccessComponent, {
						data: { title: "Failed", subTitle: "Unable to delete the user. Please try again." }
					});
					return;
				}

				this.users = this.users.filter((user: any) => user.id !== element.id);
				await this.refreshUsers('delete');
				this.dialog.open(SuccessComponent, { data: { title: "Deleted!", subTitle: "User deleted successfully." } });
			}
		});
	}

	async deleteGroup(element: any) {
		console.log("deleteSubject", element.id);
		await this.spinner.show("blockLoader");
		await this.usersService.deleteGroup(element.id).then(async (el) => {
			console.log('el', el)
			if (el) {
				await this.spinner.hide("blockLoader");
				this.dialog.open(SuccessComponent, { data: { title: "Deleted!", subTitle: "Group deleted successfully." } });
			} else {
				await this.spinner.hide("blockLoader");
				alert("Something went wrong");
			}

		});
	}

	async deleteRole(element: any) {
		console.log("deleteSubject", element.id);
		this.spinner.show("blockLoader");

		await this.usersService.deleteRole(element.id).then(async (el) => {
			// console.log('el', el);
			if (el) {
				await this.spinner.hide("blockLoader");
				this.dialog.open(SuccessComponent, { data: { title: "Deleted!", subTitle: "Role deleted successfully." } });
			} else {
				await this.spinner.hide("blockLoader");
				alert("Something went wrong");
			}
		});
	}

	// async deleteRole(element: any, data:any=null){
	// 	console.log('element',element)
	// 	const dialogRef = this.dialog.open(AlertComponent,{
	// 	  data:{
	// 		title:"Are you sure!",
	// 		subTitle:"Do you want to delete this User"
	// 	  },
	// 	});
	// 	dialogRef.afterClosed().subscribe(async result => {
	// 	  console.log(`Dialog result: ${result}`);
	// 	  await this.usersService.deleteRole(element.id).then(async (el) => {
	// 		// console.log('el', el);
	// 		if (el) {
	// 			await this.spinner.hide("blockLoader");
	// 			this.dialog.open(SuccessComponent, { data: { title: "Deleted!", subTitle: "Role deleted successfully." } });
	// 		} else {
	// 			await this.spinner.hide("blockLoader");
	// 			alert("Something went wrong");
	// 		}
	// 	});
	// 	});
	//   }

	applyFilter(event: Event) {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();

		if (this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}
	}

	async searchUsersList() {
		const searchValue = this.searchUser.trim();

		if (this.searchDebounceTimer) {
			clearTimeout(this.searchDebounceTimer);
			this.searchDebounceTimer = null;
		}

		// Invalidate any in-flight requests when search becomes too short.
		if (searchValue.length < 3) {
			this.activeSearchRequestId = ++this.searchRequestCounter;
			this.isSearchingUser = false;
			this.isSearchMode = false;
			this.searchedUsers = [];
			this.setUsersDataSource(this.getCurrentUsersSlice());
			return;
		}

		const requestId = ++this.searchRequestCounter;
		this.activeSearchRequestId = requestId;
		this.isSearchingUser = true;

			this.searchDebounceTimer = setTimeout(async () => {
				try {
					let searchRes: any = await this.usersService.searchUsersTypesense(searchValue, this.organisationId);

					// Ignore stale responses.
					if (requestId !== this.activeSearchRequestId) {
						return;
					}

					// If Typesense yields nothing, do deterministic fallback search.
					if (!searchRes || searchRes.length === 0) {
						if (!this.hasLoadedAllUsersForSearch) {
							const allUsers = await this.usersService.getAllUsers(this.organisationId);
							this.allUsersForSearch = allUsers || [];
							this.hasLoadedAllUsersForSearch = true;
						}

						searchRes = this.filterUsersLocally(searchValue, this.allUsersForSearch.length ? this.allUsersForSearch : this.users);
					}

					for (let u of searchRes) {
						const roleId = String(u.roleId);
						u.role = this.rolesData[roleId];

					if (u.level?.length) {
						for (let k = 0; k < u.level.length; k += 1) {
							let lvl = u.level[k];
							let checkVal = lvl.value;
							u.level[k].displayValue = this.getDisplayValue(checkVal, k);
						}
					}
				}

				this.isSearchMode = true;
				this.searchedUsers = searchRes;
				this.setUsersDataSource(searchRes);
			} catch (err: any) {
				if (requestId !== this.activeSearchRequestId) {
					return;
				}

				this.isSearchMode = false;
				this.searchedUsers = [];
				this.setUsersDataSource(this.getCurrentUsersSlice());
				this.snackbar.open('Unable to search users right now.', 'OK', {
					duration: 2500
				});
			} finally {
				if (requestId === this.activeSearchRequestId) {
					this.isSearchingUser = false;
				}
			}
		}, 250);
	}

	filterUsersLocally(searchValue: string, users: any[]) {
		const search = searchValue.toLowerCase();

		return users.filter((u: any) => {
			const name = String(u?.name ?? '').toLowerCase();
			const empCode = String(u?.empCode ?? '').toLowerCase();
			const email = String(u?.email ?? '').toLowerCase();
			const role = String(u?.role ?? this.rolesData[String(u?.roleId ?? '')] ?? '').toLowerCase();
			const levels = Array.isArray(u?.level)
				? u.level.map((lvl: any) => String(lvl?.displayValue ?? lvl?.value ?? '')).join(' ').toLowerCase()
				: '';

			return name.includes(search)
				|| empCode.includes(search)
				|| email.includes(search)
				|| role.includes(search)
				|| levels.includes(search);
		});
	}

	filterManagers(event: Event) {
		const filterValue = String((event.target as HTMLInputElement).value).trim().toLowerCase();
		// this.dataSourceManagers.filter = filterValue.trim().toLowerCase();

		if (filterValue.length >= 1) {
			let filteredMgrs: any = [];

			for (let mgrLoc of this.managers) {
				const managers = mgrLoc.managers;

				if (managers.length >= 1) {
					let mgrs = [];
					for (let mgr of managers) {
						// console.log(mgr);
						if (String(mgr['name']).toLowerCase().includes(filterValue)) {
							mgrs.push(mgr);
						}
					}

					if (mgrs.length >= 1) {
						filteredMgrs.push({
							location: mgrLoc.location,
							managers: [...mgrs]
						});
					}
				}
			}
			this.dataSourceManagers = new MatTableDataSource<any>(filteredMgrs);
		} else {
			this.dataSourceManagers = new MatTableDataSource<any>(this.managers);
		}
		this.dataSourceManagers.sort = this.sort;
		this.dataSourceManagers.paginator = this.paginatorUsers;
	}

	getOrganizationDetails() {
		this.orgDetailsSub = this.settingsService.getOrganisationDetailsObs(this.organisationId)?.subscribe(async (orgDetails: any) => {
			this.hierarchies = orgDetails?.hierarchies;
			this.orgCode = orgDetails.orgCode;
			this.hierarchy = orgDetails.hierarchy;
			this.numUsers = this.getSafeUsersCount(orgDetails?.numUsers, this.users.length);

			for (let u of this.users) {
				for (let k = 0; k < u.level.length; k += 1) {
					let lvl = u.level[k];
					let checkVal = lvl.value;
					u.level[k].displayValue = this.getDisplayValue(checkVal, k);
				}
			}
			await this.getManagers();
		});
		// console.log('this.hierarchies', this.hierarchies);
	}

	getSafeUsersCount(value: any, fallback: number = 0) {
		const parsed = Number(value);
		if (Number.isFinite(parsed) && parsed >= 0) {
			return Math.floor(parsed);
		}
		return Math.max(0, Number(fallback) || 0);
	}

	syncUsersCountFromLoaded() {
		const loadedUsersCount = this.getSafeUsersCount(this.users?.length, 0);
		const currentCount = this.getSafeUsersCount(this.numUsers, loadedUsersCount);
		this.numUsers = Math.max(currentCount, loadedUsersCount);
	}

	async uploadBulkUsers() {
		if (!this.xlsxFileName) {
			const xlsxFileInputBtn = document.getElementById('xlsx-file-input');

			if (xlsxFileInputBtn) {
				// Capture PostHog event when user clicks Upload Bulk
				const userEmail = localStorage.getItem('username');
				const role = localStorage.getItem('roleId');

				this.postHogService.capture('Upload bulk', {
					'User email': userEmail,
					'device_type': 'Web',
					'role': role
				});

				// console.log('click');
				xlsxFileInputBtn.click();
			}
		} else {
			await this.spinner.show("blockLoader");
			const res: any = await this.usersService.processExcelFile(this.xlsxFile, this.hierarchies, this.organisationHierarchy, this.organisationId, this.orgCode);
			await this.spinner.hide("blockLoader");
			this.clearXlsxFile();

			this.dialog.open(GeneralModalComponent, {
				maxWidth: '80%',
				minWidth: 'fit-content',
				data: {
					msg: res.msg,
					buttons: ["OK"]
				}
			});
		}
	}

	xlsxFileChange(event: any) {
		let fileList: FileList | null = event.target.files;

		if (fileList) {
			this.xlsxFileName = fileList[0].name;
			const fileSize = fileList[0].size;

			const validExtensions = [".xls", ".xlsx"];
			const fileExtension = this.xlsxFileName.substring(this.xlsxFileName.lastIndexOf('.'));

			if (validExtensions.indexOf(fileExtension) < 0) {
				this.snackbar.open(`Please select a valid archive file. Valid file types are ${validExtensions.join(", ")}.`,
					"OK");
				this.clearXlsxFile();
			} else if (fileSize > 1000000) {
				this.snackbar.open("Maximum file size is 1MB", "OK");
				this.clearXlsxFile();
			}

			let reader = new FileReader();
			this.xlsxFile = fileList[0];
			reader.onload = e => {
				let fileData: any = e.target?.result;
				this.xlsxFile = new Uint8Array(fileData);
				// console.log(this.xlsxFile);
			};
			reader.readAsArrayBuffer(this.xlsxFile);
		}
	}

	clearXlsxFile() {
		this.xlsxFileName = '';
		this.xlsxFile = '';
		const xlsxFileInput: any = document.getElementById('xlsx-file-input');
		if (xlsxFileInput) {
			xlsxFileInput.value = '';
		}
	}

	async getRoleName(roleId: string) {
		return await this.usersService.getRoleName(roleId);
	}

	async isRoleIdValid(roleId: string) {
		return await this.usersService.isRoleIdValid(roleId);
	}

	displayXlsFileInformation() {
		this.snackbar.open("Accepted file formats are .xls, .xlsx . Please make sure the file follows the sample format exactly.", "OK", {
			duration: 4000
		});
	}

	async downloadSampleXlsFile() {
		// console.log('organisationId', this.organisationId);

		this.rolesData = await this.usersService.getOrgRoles(this.organisationId);
		// console.log('rolesData', this.rolesData);

		// console.log('this.hierarchies', this.hierarchies);

		const headers = [
			'0',
			'Action',
			'Userid',
			'Name',
			'Role',
			'Password',
			...this.hierarchies.map((hierarchy: any) => hierarchy.charAt(0).toUpperCase() + hierarchy.slice(1)),
		];

		const dataRows = Object.keys(this.rolesData).map((key, index) => {
			const role = this.rolesData[key];
			return [
				index + 1,
				'A',
				`exampleuser${index + 1}@example.com`,
				`Example User${index + 1}`,
				role,
				'example1',
				...Array(this.hierarchies.length).fill(''),
			];
		});

		const wb = XLSX.utils.book_new();
		const ws = XLSX.utils.aoa_to_sheet([headers, ...dataRows]);
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const blob = new Blob([wbout], { type: 'application/octet-stream' });
		const fileName = 'Ignite-Humans_bulk-user-upload-template.xlsx';

		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.download = fileName;
		link.style.display = 'none';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}



	getUserLevels(userDetails: any) {
		let displayValues: any = [];
		// let parents = [];

		for (let i = 0; i < userDetails.level.length; i += 1) {
			const val = userDetails.level[i];

			for (let j = 0; j < this.organisationHierarchy.length; j += 1) {
				let hierarchyLevelVals = this.organisationHierarchy[j].values;

				for (let hVal of hierarchyLevelVals) {
					if (hVal.value === val.value) {
						// parents.push(val);
						displayValues.push(hVal.displayValue);
					}
				}
			}
			// parents.push(val);
		}

		return new Set(displayValues);
	}

	capitalizeFirstWord(word: string) {
		return word.charAt(0).toUpperCase() + word.slice(1);
	}

	changeSortTable(event: any) {
		if (event.active === 'location') {
			const data = this.isSearchMode ? this.searchedUsers.slice() : this.users.slice();
			const isAsc = event.direction === 'asc';
			const sortedData = data.sort((a: any, b: any) => {
				return this.compare(this.getAllLevels(a), this.getAllLevels(b), isAsc);
			});

			if (this.isSearchMode) {
				this.searchedUsers = sortedData;
				this.setUsersDataSource(this.searchedUsers);
			} else {
				this.users = sortedData;
				this.setUsersDataSource(this.getCurrentUsersSlice());
			}
		}
	}

	getCurrentUsersSlice() {
		let start = this.currentIndex[0] ?? 0;
		let end = this.currentIndex[1] ?? 0;

		if (end <= start || this.users.length < end) {
			end = Math.min(start + this.usersPageSize, this.users.length);
		}
		if (start >= this.users.length) {
			start = 0;
			end = Math.min(this.usersPageSize, this.users.length);
		}

		return this.users.slice(start, end);
	}

	setUsersDataSource(data: any[]) {
		this.dataSource = new MatTableDataSource<any>(data);
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginatorUsers;
	}

	updatePaginationState() {
		const totalLoaded = this.getSafeUsersCount(this.users?.length, 0);
		const totalCount = this.getSafeUsersCount(this.numUsers, totalLoaded);
		let start = this.getSafeUsersCount(this.currentIndex[0], 0);
		let end = this.getSafeUsersCount(this.currentIndex[1], 0);

		if (totalLoaded === 0) {
			this.currentIndex = [0, 0];
			this.hasPreviousUsers = false;
			this.hasMoreUsers = false;
			return;
		}

		if (start >= totalLoaded) {
			start = Math.max(0, totalLoaded - this.usersPageSize);
		}

		if (end <= start) {
			end = Math.min(start + this.usersPageSize, totalLoaded);
		}

		if (end > totalLoaded) {
			end = totalLoaded;
		}

		this.currentIndex = [start, end];
		this.hasPreviousUsers = start > 0;

		const canMoveWithinLoaded = end < totalLoaded;
		const hasPotentialUnloaded = this.hasMoreFromServer && totalCount > totalLoaded;
		this.hasMoreUsers = canMoveWithinLoaded || hasPotentialUnloaded;
	}

	getPaginationStartDisplay() {
		return this.currentIndex[1] > 0 ? this.currentIndex[0] + 1 : 0;
	}

	compare(a: number | string, b: number | string, isAsc: boolean) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
	}

	getAllLevels(a: any) {
		let levels = "";

		for (let level of a.level) {
			levels += level.value;
		}

		return levels;
	}

	async getManagers() {
		this.areManagersLoading = true;
		let managerIds: any = [];

		for (let i = 0; i < this.hierarchy.length; i += 1) {
			const currHierarchyLevel = this.hierarchy[i];
			const currHierarchyLevelValues = currHierarchyLevel.values;

			for (let j = 0; j < currHierarchyLevelValues.length; j += 1) {
				const currVal = currHierarchyLevelValues[j];
				if (currVal.managers && currVal.managers.length >= 1) {
					for (let k = 0; k < currVal.managers.length; k += 1) {
						let managerId = currVal.managers[k];
						if (!managerIds.includes(managerId)) {
							managerIds.push(managerId);
						}
					}
				}
			}
		}

		// console.log(managerIds);
		let idsToFetch = managerIds.filter((id: any) => {
			const x = this.managerDetails.findIndex((mgr: any) => mgr.id === id);
			if (x === -1) {
				return true;
			}
			return false;
		});

		// await this.spinner.show("blockLoader");
		// console.log(idsToFetch);
		if (idsToFetch && idsToFetch.length >= 1) {
			let fetchedIdsData: any = await this.usersService.fetchMgrDetails(idsToFetch);
			// console.log(fetchedIdsData);
			// await this.spinner.hide("blockLoader");
			this.managerDetails = [...this.managerDetails, ...fetchedIdsData];
		}

		this.managers = [];
		// console.log(this.hierarchy);
		// console.log(this.users);
		for (let i = 0; i < this.hierarchy.length; i += 1) {
			const currHierarchyLevel = this.hierarchy[i];
			const currHierarchyLevelValues = currHierarchyLevel.values;

			for (let j = 0; j < currHierarchyLevelValues.length; j += 1) {
				const currVal = currHierarchyLevelValues[j];
				let mgrs: any = [];

				if (currVal.managers && currVal.managers.length >= 1) {
					for (let k = 0; k < currVal.managers.length; k += 1) {
						let managerId = currVal.managers[k];
						// const user = this.users.find((user: any) => {
						// 	return user.id === managerId;
						// });
						// const user: any = await this.usersService.getUserDetails(managerId);
						const user = this.managerDetails.find((mgr: any) => mgr.id === managerId);
						// console.log(user);

						if (user && Object.keys(user).length >= 1) {
							mgrs.push({
								id: managerId,
								name: user.name,
								roleId: user.roleId
							});
						}
					}

					if (mgrs.length >= 1) {
						this.managers.push({
							location: [...currVal.levels, currVal.value],
							managers: [...mgrs]
						});
					}
				}
			}
		}
		// console.log(this.managers);
		this.sortManagers();

		this.areManagersLoading = false;
		this.dataSourceManagers = new MatTableDataSource<any>(this.managers);
		this.dataSourceManagers.paginator = this.paginatorManagers;
	}

	filterManagersByRole(roleId: any) {
		this.managerRoleFilterValue = roleId;

		if (roleId === "all") {
			const allManagers = this.managers;
			this.dataSourceManagers = new MatTableDataSource<any>(allManagers);
			this.dataSourceManagers.paginator = this.paginatorManagers;
		} else {
			let filteredArray: any = [];
			for (let i = 0; i < this.managers.length; i += 1) {
				const currLevel = this.managers[i];

				const managersArray = currLevel.managers.filter((user: any) => {
					return user.roleId === roleId;
				});

				if (managersArray.length >= 1) {
					filteredArray.push({
						location: currLevel.location,
						managers: [...managersArray]
					});
				}
			}

			this.dataSourceManagers = new MatTableDataSource<any>(filteredArray);
			this.dataSourceManagers.paginator = this.paginatorManagers;
		}
	}

	sortManagers() {
		const mgrsData = this.managers.slice();
		this.managers = mgrsData.sort((a: any, b: any) => {
			return this.compareMgrs(a, b);
		});
	}

	compareMgrs(a: any, b: any) {
		const locationA = a.location;
		const locationB = b.location;

		for (let i = 0; i < locationA.length; i += 1) {
			if (locationA[i] < locationB[i]) {
				return -1;
			} else if (locationA[i] > locationB[i]) {
				return 1;
			}
			continue;
		}

		if (a.managers && a.managers[0] && b.managers && b.managers[0]) {
			return a.managers[0] < b.managers[0] ? -1 : 1;
		}
	}
}
